import classNames from "classnames";

import { formatPrice } from "@jti/format-price";
import { DEPRECATED_Loading, Tooltip, Txt, useTranslations } from "@jti/ui";

import { LOYALTY_CHOICE } from "@checkout/hooks/useLoyalty";
import type { CheckoutLoyaltyPointsBodyProps } from "@checkout/types/Checkout";

import { CheckoutLoyaltyPointsBlock } from "../CheckoutLoyaltyPointsBlock";
import { CheckoutLoyaltyPointsDiscounts } from "../CheckoutLoyaltyPointsDiscounts";

export const CheckoutLoyaltyPointsToggle = ({
  minVoucherCost,
  maxVoucherValue,
  setCollect,
  setRedeem,
  cartPoints,
  userPoints,
  currency,
  redemptionTabSymbol,
  loyaltyChoice,
  vouchers,
  isQueryCampaign,
  isLoyaltyError,
  loyaltyCampaignId,
  handleCampaignChange,
}: CheckoutLoyaltyPointsBodyProps) => {
  const { __ } = useTranslations();

  const infoText = __("loyalty.checkout.additionalInfo");
  const infoIconText = __("loyalty.checkout.additionalInfoIcon");

  const isLoadingClassNames = classNames("checkout-loyalty-points__loading-indicator", {
    "checkout-loyalty-points__loading-indicator--active": isQueryCampaign,
  });

  if (cartPoints <= 0 && (!minVoucherCost || userPoints < minVoucherCost)) {
    return null;
  }

  return (
    <>
      <div className={"checkout-loyalty-points__toggle"}>
        <CheckoutLoyaltyPointsBlock
          title={`+${cartPoints}`}
          onClick={setCollect}
          isActive={loyaltyChoice === LOYALTY_CHOICE.COLLECT}
          disabled={cartPoints <= 0 && userPoints <= 0}
          text={__("loyalty.pointsBlock.collect", [cartPoints])}
          dataTestid="checkoutCollectPoints"
        />
        <CheckoutLoyaltyPointsBlock
          title={redemptionTabSymbol}
          onClick={setRedeem}
          isActive={loyaltyChoice === LOYALTY_CHOICE.REDEEM}
          text={__("loyalty.pointsBlock.redeem", [
            formatPrice({
              currency,
              value: maxVoucherValue,
            }),
          ])}
          disabled={!minVoucherCost || userPoints < minVoucherCost}
          dataTestid="checkoutRedeemPoints"
        />
      </div>
      {loyaltyChoice === LOYALTY_CHOICE.REDEEM ? (
        <section className={"checkout-loyalty-points__discounts"} data-testid="checkoutRedeem">
          <header className={"checkout-loyalty-points__discounts-header"}>
            <Txt variant={"txt-1"}>{__("loyalty.checkout.discountSelect")}</Txt>
            <div className={isLoadingClassNames}>
              <DEPRECATED_Loading />
            </div>
          </header>
          <CheckoutLoyaltyPointsDiscounts
            currency={currency}
            vouchers={vouchers}
            isQueryCampaign={isQueryCampaign}
            isLoyaltyError={isLoyaltyError}
            loyaltyCampaignId={loyaltyCampaignId}
            handleCampaignChange={handleCampaignChange}
          />
          <div className="checkout-loyalty-points__discounts--additional-info-wrapper">
            {infoIconText && infoIconText !== "loyalty.checkout.additionalInfoIcon" && (
              <Tooltip
                data-testid={"redeemPopoverButton"}
                content={
                  <span data-testid={"redeemPopoverAdditionalInfo"}>
                    {infoText && infoText !== "loyalty.checkout.additionalInfo" ? infoText : infoIconText}
                  </span>
                }
              />
            )}
            <span className="checkout-loyalty-points__discounts--additional-info">{infoIconText}</span>
          </div>
        </section>
      ) : null}
    </>
  );
};
